import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { SMS_PACKAGE_STATUS, SMS_PACKAGE_STATUS_META } from '../services/types';

type Props = {
  value: SMS_PACKAGE_STATUS;
  onChange: (value: SMS_PACKAGE_STATUS) => void;
};

const StatusDropdownTag = ({ value, onChange }: Props) => {
  const items = Object.entries(SMS_PACKAGE_STATUS_META).map(
    ([key, meta]) => ({
      key,
      label: meta.label,
    })
  );

  const current = SMS_PACKAGE_STATUS_META[value];

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items,
        onClick: ({ key }) =>
          onChange(key as SMS_PACKAGE_STATUS),
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 6,
          padding: '6px 14px',
          borderRadius: 999,
          cursor: 'pointer',
          backgroundColor: current.backgroundColor,
          color: current.color,
          fontWeight: 500,
          fontFamily: 'Poppins',
        }}
      >
        <Space size={4}>
          {current.label}
          <DownOutlined style={{ fontSize: 10 }} />
        </Space>
      </div>
    </Dropdown>
  );
};

export default StatusDropdownTag;